import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { BonusIntroSection } from '../components/BonusIntroSection';
import { BonusCardsSection } from '../components/BonusCardsSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { BonusClosingSection } from '../components/BonusClosingSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
const META_PIXEL_ID = '1248476953463026';
export function LandingPage() {
  const [orderBump1Selected, setOrderBump1Selected] = useState(false);
  const [orderBump2Selected, setOrderBump2Selected] = useState(false);
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-gray-300 selection:bg-amber-500/30 selection:text-amber-200 overflow-hidden" data-id="element-304">
      <main data-id="element-305">
        <HeroSection data-id="element-306" />
        <ProblemSection data-id="element-307" />
        <FailedSolutions data-id="element-308" />
        <MechanismSection data-id="element-309" />
        <DeliverablesSection data-id="element-310" />
        <AudienceSection data-id="element-311" />
        <ProcessSection data-id="element-312" />
        <ProofSection data-id="element-313" />
        <FAQSection data-id="element-314" />
        <BonusIntroSection data-id="element-315" />
        <BonusCardsSection data-id="element-316" />
        <ValueStackSection data-id="element-317" />
        <BonusClosingSection orderBump1Selected={orderBump1Selected} setOrderBump1Selected={setOrderBump1Selected} orderBump2Selected={orderBump2Selected} setOrderBump2Selected={setOrderBump2Selected} data-id="element-318" />
        <OfferSection orderBump1Selected={orderBump1Selected} orderBump2Selected={orderBump2Selected} data-id="element-319" />
      </main>
      <FooterSection data-id="element-320" />
      <RecentPurchaseToast data-id="element-321" />
    </div>;
}